module.exports = __webpack_public_path__ + "img/1.c66c1c6e.png";